import { Draft } from '@reduxjs/toolkit';

import { ICategoryData } from '../../index';

function createFailure(draft: Draft<ICategoryData>) {
  draft.create.config.isLoading = false;
}

export default createFailure;
